import { render, staticRenderFns } from "./card_hist.vue?vue&type=template&id=d2ddcd74&scoped=true&"
import script from "./card_hist.vue?vue&type=script&lang=js&"
export * from "./card_hist.vue?vue&type=script&lang=js&"
import style0 from "./card_hist.vue?vue&type=style&index=0&id=d2ddcd74&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2ddcd74",
  null
  
)

export default component.exports